<span class="heading">
  @if (helpInfo) {
    <mat-icon (click)="infoClicked($event)"  svgIcon="information-outline"></mat-icon>
  }
  <span [innerHTML]="title"></span>
</span>

<a [hidden]="!collapsible || disabled" mat-mini-fab class="icon toggle" color="primary">
  @if (selected) {
    <mat-icon svgIcon="x"></mat-icon>
  }
  @if (!selected) {
    <mat-icon [svgIcon]="openIcon"></mat-icon>
  }
</a>

<div style="width: 100%">
  <ng-content></ng-content>
</div>
